/*
 * @Description: vuex
 * @Autor: Dai YueLin
 * @Date: 2022-04-13 17:45:19
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-07-14 09:09:54
 */
import { createStore } from 'vuex';

import getters from './getters';

const modulesFiles = import.meta.globEager('./modules/*.ts');
const modules = Object.keys(modulesFiles).reduce((modules: any, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/modules\/(.*)\.\w+$/, '$1');
  const value = modulesFiles[modulePath];
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = createStore({
  modules,
  getters,
});

export default store;
